export default function(ac, app) {
    var komentar = app.getEntity('Komentar');
    komentar
        .listView()
        .title('Vaši komentari')
        .icon('<i class="fa fa-comments fa-3x"></i>')
        .fields([
            ac
                .field('sender')
                .label('Pošiljatelj')
                .cssClasses(['col-md-3']),
            ac
                .field('poruka')
                .label('Poruka')
                .cssClasses(['col-md-7']),
            ac
                .field('radni_nalog', 'template')
                .label('Radni nalog')
                .template(function(entry) {
                    return '<a ui-sref="radniNalog.details({id: entry.radni_nalog})" class="btn"><i class="fa fa-comments"></i> {{entry.sifra_naloga}}</a>';
                })
                .cssClasses(['col-md-2'])
        ]);

    return komentar;
}



// WEBPACK FOOTER //
// ./app/components/komentar/config.js